// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/core/v1/state.proto (package thru.core.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_thru_core_v1_types } from "./types_pb";
import type { Pubkey } from "../../common/v1/primitives_pb";
import { file_thru_common_v1_primitives } from "../../common/v1/primitives_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/core/v1/state.proto.
 */
export const file_thru_core_v1_state: GenFile = /*@__PURE__*/
  fileDesc("Chh0aHJ1L2NvcmUvdjEvc3RhdGUucHJvdG8SDHRocnUuY29yZS52MSKnAQoRU3RhdGVQcm9vZlJlcXVlc3QSLAoHYWRkcmVzcxgBIAEoCzIWLnRocnUuY29tbW9uLnYxLlB1YmtleUID4EECEjUKCnByb29mX3R5cGUYAiABKA4yHC50aHJ1LmNvcmUudjEuU3RhdGVQcm9vZlR5cGVCA+BBAhIdCgt0YXJnZXRfc2xvdBgDIAEoBEID4EEBSACIAQFCDgoMX3RhcmdldF9zbG90IjMKClN0YXRlUHJvb2YSEgoFcHJvb2YYASABKAxCA+BBAhIRCgRzbG90GAIgASgEQgPgQQIqjwEKDlN0YXRlUHJvb2ZUeXBlEiAKHFNUQVRFX1BST09GX1RZUEVfVU5TUEVDSUZJRUQQABIdChlTVEFURV9QUk9PRl9UWVBFX0NSRUFUSU5HEAESHQoZU1RBVEVfUFJPT0ZfVFlQRV9VUERBVElORxACEh0KGVNUQVRFX1BST09GX1RZUEVfRVhJU1RJTkcQA0K5AQoQY29tLnRocnUuY29yZS52MUIKU3RhdGVQcm90b1ABWkBnaXRodWIuY29tL1VudG8tTGFicy90aHJ1LW5ldC9ncnBjL3BrZy9wcm90by90aHJ1L2NvcmUvdjE7Y29yZXYxogIDVENYqgIMVGhydS5Db3JlLlYxugIEVEhVQ8oCDFRocnVcQ29yZVxWMeICGFRocnVcQ29yZVxWMVxHUEJNZXRhZGF0YeoCDlRocnU6OkNvcmU6OlYxYgZwcm90bzM", [file_google_api_field_behavior, file_thru_core_v1_types, file_thru_common_v1_primitives]);

/**
 * StateProofRequest describes a request to generate an account state proof.
 *
 * @generated from message thru.core.v1.StateProofRequest
 */
export type StateProofRequest = Message<"thru.core.v1.StateProofRequest"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey address = 1;
   */
  address?: Pubkey | undefined;

  /**
   * @generated from field: thru.core.v1.StateProofType proof_type = 2;
   */
  proofType: StateProofType;

  /**
   * @generated from field: optional uint64 target_slot = 3;
   */
  targetSlot?: bigint | undefined;
};

/**
 * Describes the message thru.core.v1.StateProofRequest.
 * Use `create(StateProofRequestSchema)` to create a new message.
 */
export const StateProofRequestSchema: GenMessage<StateProofRequest> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_state, 0);

/**
 * StateProof returns binary proof data along with context.
 *
 * @generated from message thru.core.v1.StateProof
 */
export type StateProof = Message<"thru.core.v1.StateProof"> & {
  /**
   * @generated from field: bytes proof = 1;
   */
  proof: Uint8Array;

  /**
   * @generated from field: uint64 slot = 2;
   */
  slot: bigint;
};

/**
 * Describes the message thru.core.v1.StateProof.
 * Use `create(StateProofSchema)` to create a new message.
 */
export const StateProofSchema: GenMessage<StateProof> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_state, 1);

/**
 * StateProofType selects the type of state proof to generate.
 *
 * @generated from enum thru.core.v1.StateProofType
 */
export enum StateProofType {
  /**
   * @generated from enum value: STATE_PROOF_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATE_PROOF_TYPE_CREATING = 1;
   */
  CREATING = 1,

  /**
   * @generated from enum value: STATE_PROOF_TYPE_UPDATING = 2;
   */
  UPDATING = 2,

  /**
   * @generated from enum value: STATE_PROOF_TYPE_EXISTING = 3;
   */
  EXISTING = 3,
}

/**
 * Describes the enum thru.core.v1.StateProofType.
 */
export const StateProofTypeSchema: GenEnum<StateProofType> = /*@__PURE__*/
  enumDesc(file_thru_core_v1_state, 0);

